import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { BrowserRouter } from "react-router-dom"
import { ThemeProvider } from "@mui/material/styles"
import CssBaseline from "@mui/material/CssBaseline"
import { AppTheme } from "theme-gaia"
import App from "@/App"
import "@/styles/animation.css"
import "@/styles/loader.css"
import {BASENAME_APP} from "@/config/constant.ts";
import "maplibre-gl/dist/maplibre-gl.css";


window.addEventListener("load", () => {
  const preLoader = document.getElementById("gaia-pre-loader")

  if (preLoader) {
    preLoader.classList.add("fade-out")

    setTimeout(() => {
      preLoader.remove()
    }, 800)
  }
})
createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter basename={BASENAME_APP}>
      <ThemeProvider theme={AppTheme}>
        <CssBaseline />
        <App />
      </ThemeProvider>
    </BrowserRouter>
  </StrictMode>,
)
